import React from "react";
import styled from "styled-components";
// import backgroundImg from "../../assets/background2.jpg";
import backgroundImg from "../../assets/bag.svg";
import ProfileCard from "../organisms/ProfileCard";
import AboutMe from "../organisms/AboutMe";
import { ScreenSize, useScreenSize } from "../../contexts/ScreenSizeContext";

// Container with a background image
const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  height: 800px;
  background-image: url(${backgroundImg});
  background-size: cover;
  background-position: center;
`;

// Overlay to contain inner content
const ContentOverlay = styled.div<{
  $screenSize: ScreenSize;
}>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: ${({ $screenSize }) =>
    $screenSize === "mobile" ? "column" : "row"};
  justify-content: center;
  align-items: center;
  color: #fff;
  padding: 20px;
`;

const Hero: React.FC = () => {
  const { screenSize } = useScreenSize();
  return (
    <HeaderContainer>
      <ContentOverlay $screenSize={screenSize}>
        <ProfileCard />
        <AboutMe />
      </ContentOverlay>
    </HeaderContainer>
  );
};

export default Hero;
